/**
 * White paper page behaviour.
 *
 * Citation superscripts link to entries inside a collapsed <details>. Browser
 * support for auto-expanding details on fragment navigation is uneven, so we
 * open any collapsed ancestor ourselves and then scroll the target into view.
 */
(function () {
  'use strict';

  function revealTarget(hash) {
    if (!hash || hash.length < 2) return;

    var target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      return;
    }
    if (!target) return;

    var opened = false;
    var node = target.parentElement;
    while (node) {
      if (node.tagName === 'DETAILS' && !node.open) {
        node.open = true;
        opened = true;
      }
      node = node.parentElement;
    }

    // Only re-scroll when we changed layout by expanding something; otherwise
    // the browser's own fragment scroll is already correct.
    if (opened) {
      target.scrollIntoView({ block: 'center' });
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link) return;

    var hash = link.getAttribute('href');
    if (hash === '#') return;

    // Let the browser update the URL, then reveal on the next frame.
    requestAnimationFrame(function () {
      revealTarget(hash);
    });
  });

  window.addEventListener('hashchange', function () {
    revealTarget(window.location.hash);
  });

  if (window.location.hash) {
    revealTarget(window.location.hash);
  }
})();
